import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Clear's named type roles (theme.css `--text-*`) are font sizes. Without
 * this, tailwind-merge reads `text-section-title` as a text color and drops
 * it whenever a color such as `text-foreground` follows it.
 */
const clearTypeRoles = [
  'caption',
  'reading',
  'row-title',
  'section-title',
  'page-title',
  'metric',
] as const

const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: [...clearTypeRoles] }] } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
